import React from 'react';
import { colors } from '@styles/colors';

// Componente reutilizable para las cajas de ciudad
const Box = ({ label, onClick, isSelected = false, style = {} }) => {
  return (
    <div
      onClick={onClick}
      style={{
        height: '7.0vh',
        minWidth: '14.9vh',
        padding: '0 2.0vh',
        backgroundColor: isSelected ? colors.primary : colors.gray200,
        borderRadius: '1.1vh',
        transform: 'rotate(0deg)',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2.0vh',
        fontFamily: 'Inter',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        whiteSpace: 'nowrap',
        ...style
      }}
    >
      {label}
    </div>
  );
};

export default Box;